var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"custom-widget",attrs:{"href":_vm.widget.url,"target":_setup.widgetTarget}},[_c('h5',[_vm._v(_vm._s(_vm.widget.displayText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }